import { render, staticRenderFns } from "./DashboardToBeInvoices.vue?vue&type=template&id=4c49a14e&scoped=true&"
import script from "./DashboardToBeInvoices.vue?vue&type=script&lang=js&"
export * from "./DashboardToBeInvoices.vue?vue&type=script&lang=js&"
import style0 from "./DashboardToBeInvoices.vue?vue&type=style&index=0&id=4c49a14e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c49a14e",
  null
  
)

export default component.exports